import { z } from "zod"

import { RecipientType } from "@/screens/Pricing/constants"

export const SendPriceChangeSchema = z.object({
  emailNote: z.string().min(1, { message: "Email note is required" }),
})

export const ReSendToIndividualSchema = SendPriceChangeSchema.extend({
  contactId: z.string().optional().nullish(),
  customerId: z.string().optional().nullish(),
  recipientType: z
    .nativeEnum(RecipientType)
    .nullable()
    .refine((value): boolean => value?.trim() !== "" && value !== null, { message: "Recipient Type is required" }),
}).superRefine((values, ctx) => {
  if (values.recipientType === RecipientType.Contact && !values.contactId) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: "Contact is Required",
      path: ["contactId"],
    })
  }

  if (values.recipientType === RecipientType.Customer && !values.customerId) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: "Customer is Required",
      path: ["customerId"],
    })
  }
})

export type SendPriceChangeSchemaFormValues = z.infer<typeof SendPriceChangeSchema>
export type ReSendToIndividualSchemaFormValues = z.infer<typeof ReSendToIndividualSchema>
